<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card class="mTop">
        <div slot="header" class="clearfix">
          <span>赠送卡片排名</span>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            label="排名"
            align="center"
          >
            <template scope="scope">
              {{ scope.$index +1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="玩家UID"
          >
            <template slot-scope="scope">
              <a href="javascript:;" style="color: #0e6cff;text-decoration:underline;text-underline: #1c84c6;" @click="gotoreward(scope.row.uid)"> {{ scope.row.uid }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="赠送卡数量"
            align="center"
          />
          <el-table-column
            prop="count"
            label="剩余卡数量"
            align="center"
          />
        </el-table>
      </el-card>

      <el-card class="mTop">
        <div slot="header" class="clearfix">
          <span>赠送卡片数量分布</span>
        </div>
        <cardBumStat ref="cardStat" :k="'num'" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getSendCardStat } from '@/api/user/user_info'
import cardBumStat from '@/views/config/send-stat/components/card-num-stat.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'SendCard',
  components: {
    cardBumStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        type: 1
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }

    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      this.queryParams.type = 1
      getSendCardStat(this.queryParams).then(res => {
        this.tableData = res.data.rank
        this.$refs.cardStat.refresh(res.data.num, res.data.cardInfo)
      })
    },
    gotoreward(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    }
  }
}
</script>

<style scoped>
.mTop{
  margin-top: 10px;
}
</style>
